var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _g, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 135,
    viewBox: "0 0 169 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.66 36.7036C120.976 37.3194 122.002 38.423 122.519 39.7811C122.519 39.7811 122.289 36.316 123.894 34.9374C123.894 34.9374 122.441 36.0868 122.134 37.7721C121.439 37.1703 120.575 36.7972 119.66 36.7036Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.524 28.0173C112.524 28.0173 115.187 30.087 115.915 31.9948C115.915 31.9948 116.323 29.9488 118.251 29.3353C117.795 29.3285 117.344 29.433 116.937 29.6398C116.53 29.8465 116.179 30.1492 115.915 30.5218C115.083 29.3449 113.894 28.4669 112.524 28.0173Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.679 37.0206C109.679 37.0206 111.86 36.6836 112.905 38.0116C112.905 38.0116 112.258 36.0297 112.905 34.6881C112.905 34.6881 112.042 35.2409 112.342 37.233C112.342 37.233 111.513 36.3768 109.679 37.0206Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.536 110.357H0V110.441H168.536V110.357Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4014 112.653H35.2375V112.737H46.4014V112.653Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4222 115.74H57.6865V115.825H71.4222V115.74Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9002 114.685H17.6826V114.769H34.9002V114.685Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.648 113.219H120.253V113.303H151.648V113.219Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.674 114.641H93.4395V114.726H107.674V114.641Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8858 95.3238H14.8007C14.2908 95.3229 13.8021 95.1197 13.4419 94.7589C13.0817 94.398 12.8794 93.909 12.8794 93.3991V1.90782C12.8838 1.40088 13.0881 0.916153 13.4478 0.558938C13.8076 0.201723 14.2937 0.000868426 14.8007 0H79.8858C80.3963 0 80.8858 0.202778 81.2468 0.563725C81.6077 0.924672 81.8105 1.41422 81.8105 1.92468V93.3991C81.8105 93.9095 81.6077 94.3991 81.2468 94.76C80.8858 95.121 80.3963 95.3238 79.8858 95.3238ZM14.8007 0.0674145C14.3132 0.0683074 13.8459 0.262601 13.5015 0.607647C13.1571 0.952694 12.9637 1.4203 12.9637 1.90782V93.3991C12.9637 93.8866 13.1571 94.3542 13.5015 94.6993C13.8459 95.0443 14.3132 95.2386 14.8007 95.2395H79.8858C80.3734 95.2377 80.8404 95.0433 81.1852 94.6985C81.53 94.3537 81.7244 93.8866 81.7262 93.3991V1.90782C81.7244 1.42026 81.53 0.95318 81.1852 0.60842C80.8404 0.263661 80.3734 0.0691907 79.8858 0.0674145H14.8007Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M152.798 95.3238H87.7093C87.1994 95.322 86.7109 95.1186 86.3504 94.7581C85.9898 94.3975 85.7864 93.909 85.7847 93.3991V1.90782C85.79 1.40057 85.995 0.915849 86.3553 0.558727C86.7156 0.201605 87.2021 0.000858955 87.7093 0H152.798C153.304 0.00175429 153.789 0.203001 154.148 0.560121C154.508 0.917241 154.711 1.40146 154.716 1.90782V93.3991C154.716 93.6514 154.667 93.9013 154.571 94.1346C154.475 94.3679 154.333 94.5799 154.155 94.7586C153.977 94.9374 153.766 95.0793 153.533 95.1762C153.3 95.2732 153.05 95.3233 152.798 95.3238ZM87.7093 0.0674145C87.2218 0.0691907 86.7547 0.263661 86.4099 0.60842C86.0652 0.95318 85.8707 1.42026 85.8689 1.90782V93.3991C85.8707 93.8866 86.0652 94.3537 86.4099 94.6985C86.7547 95.0433 87.2218 95.2377 87.7093 95.2395H152.798C153.285 95.2377 153.752 95.0433 154.097 94.6985C154.442 94.3537 154.636 93.8866 154.638 93.3991V1.90782C154.636 1.42026 154.442 0.95318 154.097 0.60842C153.752 0.263661 153.285 0.0691907 152.798 0.0674145H87.7093Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.376 17.949H99.3619C99.3619 17.949 97.7237 15.3806 94.9227 16.6648C94.9227 16.6648 94.3968 13.9682 92.5868 13.921C92.0912 13.8843 91.5955 13.9921 91.16 14.2314C90.7244 14.4707 90.3676 14.8313 90.1329 15.2693C90.1329 15.2693 88.0296 11.9997 84.8173 12.7008C83.9233 12.8736 83.1054 13.3206 82.4771 13.9797C81.8489 14.6387 81.4416 15.4771 81.3117 16.3783C81.3117 16.3783 76.5152 13.921 72.376 17.949Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0557 55.5191H50.0214C50.0214 55.5191 48.3866 52.9472 45.5821 54.2314C45.5821 54.2314 45.0563 51.5349 43.2462 51.4877C42.7509 51.4526 42.2559 51.5612 41.8207 51.8003C41.3854 52.0395 41.0284 52.399 40.7924 52.836C40.7924 52.836 38.6924 49.563 35.4801 50.2641C34.5907 50.4394 33.7775 50.8863 33.1527 51.5431C32.5279 52.1999 32.1221 53.0344 31.9914 53.9314C31.9914 53.9314 27.2016 51.4877 23.0557 55.5191Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.576 37.3509H152.558C152.558 37.3509 150.924 34.7824 148.119 36.0667C148.119 36.0667 147.597 33.3701 145.783 33.3229C145.288 33.2868 144.793 33.395 144.358 33.6342C143.924 33.8735 143.567 34.2337 143.333 34.6712C143.333 34.6712 141.23 31.4016 138.017 32.1027C137.123 32.2755 136.305 32.7225 135.677 33.3815C135.049 34.0406 134.642 34.8789 134.512 35.7801C134.512 35.7801 129.722 33.3229 125.576 37.3509Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.912 21.3127C124.26 19.8436 123.351 18.3705 121.882 18.0224C120.413 17.6743 118.94 18.5831 118.592 20.0522C118.244 21.5212 119.153 22.9943 120.622 23.3424C122.091 23.6905 123.564 22.7818 123.912 21.3127Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4771 37.3509H47.4596C47.4596 37.3509 45.8417 34.7824 43.0204 36.0667C43.0204 36.0667 42.4945 33.3701 40.6845 33.3229C40.1894 33.2868 39.6945 33.395 39.2596 33.6342C38.8247 33.8735 38.4685 34.2337 38.234 34.6712C38.234 34.6712 36.1306 31.4016 32.9184 32.1027C32.0244 32.2755 31.2065 32.7225 30.5782 33.3815C29.95 34.0406 29.5426 34.8789 29.4128 35.7801C29.4128 35.7801 24.623 33.3229 20.4771 37.3509Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8572 45.5282H40.2466V101.364H68.8572V45.5282Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6562 45.5282H40.2466V101.364H63.6562V45.5282Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1942 45.5282H39.6296V46.4383H69.1942V45.5282Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1942 43.7047H39.6296V44.6148H69.1942V43.7047Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5741 44.6147H40.2466V45.5248H68.5741V44.6147Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 48.8147H42.4678V53.2101H46.8632V48.8147Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 48.8147H42.8552V53.2101H46.863V48.8147Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 48.8147H49.1282V53.2101H53.5236V48.8147Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 48.8147H49.5156V53.2101H53.5234V48.8147Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 48.8147H55.7854V53.2101H60.1808V48.8147Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 48.8147H56.1731V53.2101H60.1809V48.8147Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 55.2898H42.4678V59.6852H46.8632V55.2898Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 55.2898H42.8552V59.6852H46.863V55.2898Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 55.2898H49.1282V59.6852H53.5236V55.2898Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 55.2898H49.5156V59.6852H53.5234V55.2898Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 55.2898H55.7854V59.6852H60.1808V55.2898Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 55.2898H56.1731V59.6852H60.1809V55.2898Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 67.1447H42.4678V71.5401H46.8632V67.1447Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 67.1447H42.8552V71.5401H46.863V67.1447Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 67.1447H49.1282V71.5401H53.5236V67.1447Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 67.1447H49.5156V71.5401H53.5234V67.1447Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 67.1447H55.7854V71.5401H60.1808V67.1447Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 67.1447H56.1731V71.5401H60.1809V67.1447Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 73.6198H42.4678V78.0152H46.8632V73.6198Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 73.6198H42.8552V78.0152H46.863V73.6198Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 73.6198H49.1282V78.0152H53.5236V73.6198Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 73.6198H49.5156V78.0152H53.5234V73.6198Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 73.6198H55.7854V78.0152H60.1808V73.6198Z",
    fill: "#E6E6E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 73.6198H56.1731V78.0152H60.1809V73.6198Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 86.7959H42.4678V91.1913H46.8632V86.7959Z",
    fill: "#E6E6E6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 86.7959H42.8552V91.1913H46.863V86.7959Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 86.7959H49.1282V91.1913H53.5236V86.7959Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 86.7959H49.5156V91.1913H53.5234V86.7959Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 86.7959H55.7854V91.1913H60.1808V86.7959Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 86.7959H56.1731V91.1913H60.1809V86.7959Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8632 93.271H42.4678V97.6664H46.8632V93.271Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.863 93.271H42.8552V97.6664H46.863V93.271Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5236 93.271H49.1282V97.6664H53.5236V93.271Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 93.271H49.5156V97.6664H53.5234V93.271Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 93.271H55.7854V97.6664H60.1808V93.271Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1809 93.271H56.1731V97.6664H60.1809V93.271Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8572 62.7761H40.2466V63.184H68.8572V62.7761Z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8572 83.0443H40.2466V83.4522H68.8572V83.0443Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4164 62.2469H15.627V110.401H35.4164V62.2469Z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7806 62.2469H15.627V110.401H29.7806V62.2469Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 66.2042H17.083V68.7626H22.3514V66.2042Z",
    fill: "#E6E6E6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 66.2042H17.4333V68.7626H22.3512V66.2042Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 66.2042H23.1772V68.7626H28.4457V66.2042Z",
    fill: "#E6E6E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 66.2042H23.5278V68.7626H28.4423V66.2042Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 71.0176H17.083V73.5759H22.3514V71.0176Z",
    fill: "#E6E6E6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 71.0176H17.4333V73.5759H22.3512V71.0176Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 71.0176H23.1772V73.5759H28.4457V71.0176Z",
    fill: "#E6E6E6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 71.0176H23.5278V73.5759H28.4423V71.0176Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 77.1692H17.083V79.7276H22.3514V77.1692Z",
    fill: "#E6E6E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 77.1692H17.4333V79.7276H22.3512V77.1692Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 77.1692H23.1772V79.7276H28.4457V77.1692Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 77.1692H23.5278V79.7276H28.4423V77.1692Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 80.7017H17.083V83.26H22.3514V80.7017Z",
    fill: "#E6E6E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 80.7017H17.4333V83.26H22.3512V80.7017Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 80.7017H23.1772V83.26H28.4457V80.7017Z",
    fill: "#E6E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 80.7017H23.5278V83.26H28.4423V80.7017Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 86.5094H17.083V89.0678H22.3514V86.5094Z",
    fill: "#E6E6E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 86.5094H17.4333V89.0678H22.3512V86.5094Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 86.5094H23.1772V89.0678H28.4457V86.5094Z",
    fill: "#E6E6E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 86.5094H23.5278V89.0678H28.4423V86.5094Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 90.0419H17.083V92.6002H22.3514V90.0419Z",
    fill: "#E6E6E6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 90.0419H17.4333V92.6002H22.3512V90.0419Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 90.0419H23.1772V92.6002H28.4457V90.0419Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 90.0419H23.5278V92.6002H28.4423V90.0419Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 96.3619H17.083V98.9203H22.3514V96.3619Z",
    fill: "#E6E6E6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 96.3619H17.4333V98.9203H22.3512V96.3619Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 96.3619H23.1772V98.9203H28.4457V96.3619Z",
    fill: "#E6E6E6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 96.3619H23.5278V98.9203H28.4423V96.3619Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 101.027H17.083V103.585H22.3514V101.027Z",
    fill: "#E6E6E6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3512 101.027H17.4333V103.585H22.3512V101.027Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4457 101.027H23.1772V103.585H28.4457V101.027Z",
    fill: "#E6E6E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 101.027H23.5278V103.585H28.4423V101.027Z",
    fill: "#F5F5F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.4164 75.15H15.627V75.5916H35.4164V75.15Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.4164 84.6622H15.627V85.1038H35.4164V84.6622Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.4164 94.2585H15.627V94.6967H35.4164V94.2585Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4129 60.8212H14.6931V62.3582H35.4129V60.8212Z",
    fill: "#E0E0E0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.4163 60.8212H30.6804V62.3582H35.4163V60.8212Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 37.1655H80.6816V97.5586H103.919V37.1655Z",
    fill: "#E6E6E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M95.317 37.1655H72.0793V97.5586H95.317V37.1655Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 41.2643H74.1084V44.3417H93.2911V41.2643Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 41.2643H74.8501V44.3417H93.2879V41.2643Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 46.4451H74.1084V49.5225H93.2911V46.4451Z",
    fill: "#E6E6E6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 46.4451H74.8501V49.5225H93.2879V46.4451Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 51.8247H74.1084V54.9022H93.2911V51.8247Z",
    fill: "#E6E6E6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 51.8247H74.8501V54.9022H93.2879V51.8247Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 57.2078H74.1084V60.2852H93.2911V57.2078Z",
    fill: "#E6E6E6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 57.2078H74.8501V60.2852H93.2879V57.2078Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 62.5874H74.1084V65.6649H93.2911V62.5874Z",
    fill: "#E6E6E6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 62.5874H74.8501V65.6649H93.2879V62.5874Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 67.9705H74.1084V71.0479H93.2911V67.9705Z",
    fill: "#E6E6E6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 67.9705H74.8501V71.0479H93.2879V67.9705Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 73.8995H74.1084V76.977H93.2911V73.8995Z",
    fill: "#E6E6E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 73.8995H74.8501V76.977H93.2879V73.8995Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 79.832H74.1084V82.9095H93.2911V79.832Z",
    fill: "#E6E6E6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 79.832H74.8501V82.9095H93.2879V79.832Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 85.7644H74.1084V88.8419H93.2911V85.7644Z",
    fill: "#E6E6E6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 85.7644H74.8501V88.8419H93.2879V85.7644Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2911 91.6935H74.1084V94.7709H93.2911V91.6935Z",
    fill: "#E6E6E6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2879 91.6935H74.8501V94.7709H93.2879V91.6935Z",
    fill: "#F5F5F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M104.523 36.5587H71.4221V38.0317H104.523V36.5587Z",
    fill: "#E0E0E0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M104.523 33.8993H71.4221V35.3723H104.523V33.8993Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M103.424 35.0824H72.0793V36.5554H103.424V35.0824Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 41.2643H97.4441V44.3417H103.919V41.2643Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 46.3271H97.4441V49.4046H103.919V46.3271Z",
    fill: "#E0E0E0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 51.3933H97.4441V54.4708H103.919V51.3933Z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 57.2043H97.4441V60.2818H103.919V57.2043Z",
    fill: "#E0E0E0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 62.5874H97.4441V65.6649H103.919V62.5874Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 67.9705H97.4441V71.0479H103.919V67.9705Z",
    fill: "#E0E0E0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 73.8995H97.4441V76.977H103.919V73.8995Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 79.832H97.4441V82.9095H103.919V79.832Z",
    fill: "#E0E0E0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 85.7611H97.4441V88.8386H103.919V85.7611Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 91.6935H97.4441V94.7709H103.919V91.6935Z",
    fill: "#E0E0E0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 83.4893H154.652V86.4049H156.516V83.4893Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 88.2621H154.652V91.1777H156.516V88.2621Z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 92.8969H154.652V95.8125H156.516V92.8969Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 97.8013H154.652V100.717H156.516V97.8013Z",
    fill: "#E0E0E0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 102.571H154.652V105.486H156.516V102.571Z",
    fill: "#E0E0E0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M156.516 80.5601H136.908V110.381H156.516V80.5601Z",
    fill: "#E6E6E6"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M153.206 80.5601H136.912V110.381H153.206V80.5601Z",
    fill: "#F0F0F0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 83.4893H138.378V86.4049H151.628V83.4893Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 88.2621H138.378V91.1777H151.628V88.2621Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 93.0316H138.378V95.9473H151.628V93.0316Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 97.8013H138.378V100.717H151.628V97.8013Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 102.571H138.378V105.486H151.628V102.571Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 83.4893H138.863V86.4049H151.625V83.4893Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 88.2621H138.863V91.1777H151.625V88.2621Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 93.0316H138.863V95.9473H151.625V93.0316Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 97.8013H138.863V100.717H151.625V97.8013Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M151.625 102.571H138.863V105.486H151.625V102.571Z",
    fill: "#F5F5F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5823 55.4551H40.2021V120.597H73.5823V55.4551Z",
    fill: "#1A446F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.515 55.4551H40.2021V120.597H67.515V55.4551Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9769 55.4551H39.4844V56.5169H73.9769V55.4551Z",
    fill: "#1A446F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9769 53.3281H39.4844V54.3933H73.9769V53.3281Z",
    fill: "#1A446F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M73.252 54.3933H40.2021V55.4551H73.252V54.3933Z",
    fill: "#F0F0F0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 59.2909H42.7944V64.4211H47.9247V59.2909Z",
    fill: "#1A446F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 59.2909H43.2461V64.4211H47.9246V59.2909Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 59.2909H50.564V64.4211H55.6942V59.2909Z",
    fill: "#1A446F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 59.2909H51.0154V64.4211H55.6939V59.2909Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 59.2909H58.3298V64.4211H63.4601V59.2909Z",
    fill: "#1A446F"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 59.2909H58.7817V64.4211H63.4603V59.2909Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 66.8447H42.7944V71.975H47.9247V66.8447Z",
    fill: "#1A446F"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 66.8447H43.2461V71.975H47.9246V66.8447Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 66.8447H50.564V71.975H55.6942V66.8447Z",
    fill: "#1A446F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 66.8447H51.0154V71.975H55.6939V66.8447Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 66.8447H58.3298V71.975H63.4601V66.8447Z",
    fill: "#1A446F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 66.8447H58.7817V71.975H63.4603V66.8447Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 80.6747H42.7944V85.8049H47.9247V80.6747Z",
    fill: "#1A446F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 80.6747H43.2461V85.8049H47.9246V80.6747Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 80.6747H50.564V85.8049H55.6942V80.6747Z",
    fill: "#1A446F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 80.6747H51.0154V85.8049H55.6939V80.6747Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 80.6747H58.3298V85.8049H63.4601V80.6747Z",
    fill: "#1A446F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 80.6747H58.7817V85.8049H63.4603V80.6747Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 88.2285H42.7944V93.3587H47.9247V88.2285Z",
    fill: "#1A446F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 88.2285H43.2461V93.3587H47.9246V88.2285Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 88.2285H50.564V93.3587H55.6942V88.2285Z",
    fill: "#1A446F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 88.2285H51.0154V93.3587H55.6939V88.2285Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 88.2285H58.3298V93.3587H63.4601V88.2285Z",
    fill: "#1A446F"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 88.2285H58.7817V93.3587H63.4603V88.2285Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 103.602H42.7944V108.733H47.9247V103.602Z",
    fill: "#1A446F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 103.602H43.2461V108.733H47.9246V103.602Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 103.602H50.564V108.733H55.6942V103.602Z",
    fill: "#1A446F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 103.602H51.0154V108.733H55.6939V103.602Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 103.602H58.3298V108.733H63.4601V103.602Z",
    fill: "#1A446F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 103.602H58.7817V108.733H63.4603V103.602Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 111.156H42.7944V116.286H47.9247V111.156Z",
    fill: "#1A446F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9246 111.156H43.2461V116.286H47.9246V111.156Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6942 111.156H50.564V116.286H55.6942V111.156Z",
    fill: "#1A446F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6939 111.156H51.0154V116.286H55.6939V111.156Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4601 111.156H58.3298V116.286H63.4601V111.156Z",
    fill: "#1A446F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4603 111.156H58.7817V116.286H63.4603V111.156Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.5823 75.5815H40.2021V76.0568H73.5823V75.5815Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.5823 99.2238H40.2021V99.699H73.5823V99.2238Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M119.542 64.4211H96.4561V120.597H119.542V64.4211Z",
    fill: "#1A446F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.017 64.4211H96.4561V120.597H114.017V64.4211Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 69.0356H98.1582V72.0187H104.303V69.0356Z",
    fill: "#1A446F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 69.0356H98.5662V72.0187H104.303V69.0356Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 69.0356H105.267V72.0187H111.412V69.0356Z",
    fill: "#1A446F"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 69.0356H105.675V72.0187H111.412V69.0356Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 74.6512H98.1582V77.6343H104.303V74.6512Z",
    fill: "#1A446F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 74.6512H98.5662V77.6343H104.303V74.6512Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 74.6512H105.267V77.6343H111.412V74.6512Z",
    fill: "#1A446F"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 74.6512H105.675V77.6343H111.412V74.6512Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 81.8275H98.1582V84.8106H104.303V81.8275Z",
    fill: "#1A446F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 81.8275H98.5662V84.8106H104.303V81.8275Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 81.8275H105.267V84.8106H111.412V81.8275Z",
    fill: "#1A446F"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 81.8275H105.675V84.8106H111.412V81.8275Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 85.9498H98.1582V88.9329H104.303V85.9498Z",
    fill: "#1A446F"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 85.9498H98.5662V88.9329H104.303V85.9498Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 85.9498H105.267V88.9329H111.412V85.9498Z",
    fill: "#1A446F"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 85.9498H105.675V88.9329H111.412V85.9498Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 92.7251H98.1582V95.7082H104.303V92.7251Z",
    fill: "#1A446F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 92.7251H98.5662V95.7082H104.303V92.7251Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 92.7251H105.267V95.7082H111.412V92.7251Z",
    fill: "#1A446F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 92.7251H105.675V95.7082H111.412V92.7251Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 96.8474H98.1582V99.8305H104.303V96.8474Z",
    fill: "#1A446F"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 96.8474H98.5662V99.8305H104.303V96.8474Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 96.8474H105.267V99.8305H111.412V96.8474Z",
    fill: "#1A446F"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 96.8474H105.675V99.8305H111.412V96.8474Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 104.219H98.1582V107.202H104.303V104.219Z",
    fill: "#1A446F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 104.219H98.5662V107.202H104.303V104.219Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 104.219H105.267V107.202H111.412V104.219Z",
    fill: "#1A446F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 104.219H105.675V107.202H111.412V104.219Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M104.303 109.666H98.1582V112.649H104.303V109.666Z",
    fill: "#1A446F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.303 109.666H98.5662V112.649H104.303V109.666Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M111.412 109.666H105.267V112.649H111.412V109.666Z",
    fill: "#1A446F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.412 109.666H105.675V112.649H111.412V109.666Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M119.546 62.7594H95.3708V64.5526H119.546V62.7594Z",
    fill: "#1A446F"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.546 62.7594H114.021V64.5526H119.546V62.7594Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4559 89.2262H94.2817V92.6272H96.4559V89.2262Z",
    fill: "#E0E0E0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4559 94.7913H94.2817V98.1923H96.4559V94.7913Z",
    fill: "#E0E0E0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4559 100.201H94.2817V103.602H96.4559V100.201Z",
    fill: "#E0E0E0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4559 105.921H94.2817V109.322H96.4559V105.921Z",
    fill: "#E0E0E0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4559 111.486H94.2817V114.887H96.4559V111.486Z",
    fill: "#E0E0E0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4562 85.8083H73.5825V120.597H96.4562V85.8083Z",
    fill: "#1A446F"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.5933 85.8049H73.5825V120.597H92.5933V85.8049Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7494 89.2262H75.2913V92.6272H90.7494V89.2262Z",
    fill: "#1A446F"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7494 94.7913H75.2913V98.1923H90.7494V94.7913Z",
    fill: "#1A446F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7494 100.356H75.2913V103.757H90.7494V100.356Z",
    fill: "#1A446F"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7494 105.921H75.2913V109.322H90.7494V105.921Z",
    fill: "#1A446F"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7494 111.486H75.2913V114.887H90.7494V111.486Z",
    fill: "#1A446F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7493 89.2262H75.8608V92.6272H90.7493V89.2262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.749 94.7913H75.8606V98.1923H90.749V94.7913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.749 100.356H75.8606V103.757H90.749V100.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.749 105.921H75.8606V109.322H90.749V105.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.749 111.486H75.8606V114.887H90.749V111.486Z",
    fill: "white"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M26.487 96.4935H11.1401V120.597H35.6317V96.4935V85.8049L26.487 96.4935Z",
    fill: "#1A446F"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2025 85.8049H35.6318V120.597H40.2025V85.8049Z",
    fill: "#1A446F"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.2025 85.8049H35.6318V120.597H40.2025V85.8049Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.5824 56.5168H67.5117V120.597H73.5824V56.5168Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.4561 85.8049H92.5933V120.597H96.4561V85.8049Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M119.546 64.5526H114.021V120.597H119.546V64.5526Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 54.9225H121.908V58.5123H122.778V54.9225Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 60.9628H121.908V64.5526H122.778V60.9628Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 67.2424H121.908V70.8322H122.778V67.2424Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 73.5221H121.908V77.1119H122.778V73.5221Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 79.7983H121.908V83.3882H122.778V79.7983Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 86.078H121.908V89.6678H122.778V86.078Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 92.998H121.908V96.5879H122.778V92.998Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 99.9181H121.908V103.508H122.778V99.9181Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 106.835H121.908V110.425H122.778V106.835Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.778 113.755H121.908V117.345H122.778V113.755Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 50.1394H129.58V120.597H156.691V50.1394Z",
    fill: "#1A446F"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M146.653 50.1394H119.542V120.597H146.653V50.1394Z",
    fill: "#1A446F"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M156.691 51.1506H146.656V120.597H156.691V51.1506Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 54.9225H149.137V58.5123H156.691V54.9225Z",
    fill: "#1A446F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 60.828H149.137V64.4178H156.691V60.828Z",
    fill: "#1A446F"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 66.7368H149.137V70.3266H156.691V66.7368Z",
    fill: "#1A446F"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 73.5187H149.137V77.1085H156.691V73.5187Z",
    fill: "#1A446F"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 79.7983H149.137V83.3882H156.691V79.7983Z",
    fill: "#1A446F"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 86.078H149.137V89.6678H156.691V86.078Z",
    fill: "#1A446F"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 92.9948H149.137V96.5846H156.691V92.9948Z",
    fill: "#1A446F"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 99.9148H149.137V103.505H156.691V99.9148Z",
    fill: "#1A446F"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 106.835H149.137V110.425H156.691V106.835Z",
    fill: "#1A446F"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M156.691 113.755H149.137V117.345H156.691V113.755Z",
    fill: "#1A446F"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 54.9225H149.137V58.5123H156.691V54.9225Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 60.828H149.137V64.4178H156.691V60.828Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 66.7368H149.137V70.3266H156.691V66.7368Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 73.5187H149.137V77.1085H156.691V73.5187Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 79.7983H149.137V83.3882H156.691V79.7983Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 86.078H149.137V89.6678H156.691V86.078Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 92.9948H149.137V96.5846H156.691V92.9948Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 99.9148H149.137V103.505H156.691V99.9148Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 106.835H149.137V110.425H156.691V106.835Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.691 113.755H149.137V117.345H156.691V113.755Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.653 50.1394H119.542V120.597H146.653V50.1394Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 54.9225H121.908V58.5123H144.29V54.9225Z",
    fill: "#1A446F"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 54.9225H122.778V58.5123H144.29V54.9225Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 60.9628H121.908V64.5526H144.29V60.9628Z",
    fill: "#1A446F"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 60.9628H122.778V64.5526H144.29V60.9628Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 67.2424H121.908V70.8322H144.29V67.2424Z",
    fill: "#1A446F"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 67.2424H122.778V70.8322H144.29V67.2424Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 73.5221H121.908V77.1119H144.29V73.5221Z",
    fill: "#1A446F"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 73.5221H122.778V77.1119H144.29V73.5221Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 79.7983H121.908V83.3882H144.29V79.7983Z",
    fill: "#1A446F"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 79.7983H122.778V83.3882H144.29V79.7983Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 86.078H121.908V89.6678H144.29V86.078Z",
    fill: "#1A446F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 86.078H122.778V89.6678H144.29V86.078Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 92.998H121.908V96.5879H144.29V92.998Z",
    fill: "#1A446F"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 92.998H122.778V96.5879H144.29V92.998Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 99.9181H121.908V103.508H144.29V99.9181Z",
    fill: "#1A446F"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 99.9181H122.778V103.508H144.29V99.9181Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 106.835H121.908V110.425H144.29V106.835Z",
    fill: "#1A446F"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 106.835H122.778V110.425H144.29V106.835Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 113.755H121.908V117.345H144.29V113.755Z",
    fill: "#1A446F"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.29 113.755H122.778V117.345H144.29V113.755Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M156.111 48.0461H146.656V49.4281H156.111V48.0461Z",
    fill: "#1A446F"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M156.111 47.7092H119.542V49.4283H156.111V47.7092Z",
    fill: "#F0F0F0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M157.395 49.4316H118.777V51.1507H157.395V49.4316Z",
    fill: "#1A446F"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M157.395 46.3271H118.777V48.0462H157.395V46.3271Z",
    fill: "#1A446F"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.395 49.4316H118.777V51.1507H157.395V49.4316Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.395 46.3271H118.777V48.0462H157.395V46.3271Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.542 79.3905H96.4561V79.9028H119.542V79.3905Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.542 90.4902H96.4561V91.0026H119.542V90.4902Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.542 101.684H96.4561V102.197H119.542V101.684Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.9734 55.4551H67.5117V56.5169H73.9734V55.4551Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.9734 53.3281H67.5117V54.3899H73.9734V53.3281Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.395 49.4316H146.656V51.1507H157.395V49.4316Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.395 46.3271H146.656V48.0462H157.395V46.3271Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.487 96.4935H11.1401V120.597H35.6317V96.4935V85.8049L26.487 96.4935Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 101.381H13.3613V105.025H17.0051V101.381Z",
    fill: "#1A446F"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4206 101.381H20.7769V105.025H24.4206V101.381Z",
    fill: "#1A446F"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8361 101.381H28.1924V105.025H31.8361V101.381Z",
    fill: "#1A446F"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 107.512H13.3613V111.156H17.0051V107.512Z",
    fill: "#1A446F"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4206 107.512H20.7769V111.156H24.4206V107.512Z",
    fill: "#1A446F"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8361 107.512H28.1924V111.156H31.8361V107.512Z",
    fill: "#1A446F"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 113.644H13.3613V117.287H17.0051V113.644Z",
    fill: "#1A446F"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4206 113.644H20.7769V117.287H24.4206V113.644Z",
    fill: "#1A446F"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8361 113.644H28.1924V117.287H31.8361V113.644Z",
    fill: "#1A446F"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.4096 101.381H13.7659V105.025H17.4096V101.381Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.8217 101.381H21.178V105.025H24.8217V101.381Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2372 101.381H28.5935V105.025H32.2372V101.381Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.4096 107.512H13.7659V111.156H17.4096V107.512Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.8217 107.512H21.178V111.156H24.8217V107.512Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2372 107.512H28.5935V111.156H32.2372V107.512Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.4096 113.644H13.7659V117.287H17.4096V113.644Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.8217 113.644H21.178V117.287H24.8217V113.644Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2372 113.644H28.5935V117.287H32.2372V113.644Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M82.279 123.392L80.1689 134.097H87.2508L86.5329 123.392H82.279Z",
    fill: "#1A446F"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8992 123.392L91.9328 134.097H96.6788L92.789 123.392H88.8992Z",
    fill: "#1A446F"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4585 123.392L101.701 134.097H107.087L98.9741 123.392H95.4585Z",
    fill: "#1A446F"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M101.792 123.392L112.137 134.097H118.578L105.652 123.392H101.792Z",
    fill: "#1A446F"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6363 123.392L76.6027 134.097H71.8567L75.7465 123.392H79.6363Z",
    fill: "#1A446F"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M73.077 123.392L66.8344 134.097H61.448L69.5613 123.392H73.077Z",
    fill: "#1A446F"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7434 123.392L56.3987 134.097H49.9573L62.884 123.392H66.7434Z",
    fill: "#1A446F"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82.279 123.392L80.1689 134.097H87.2508L86.5329 123.392H82.279Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.8992 123.392L91.9328 134.097H96.6788L92.789 123.392H88.8992Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95.4585 123.392L101.701 134.097H107.087L98.9741 123.392H95.4585Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M101.792 123.392L112.137 134.097H118.578L105.652 123.392H101.792Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.6363 123.392L76.6027 134.097H71.8567L75.7465 123.392H79.6363Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.077 123.392L66.8344 134.097H61.448L69.5613 123.392H73.077Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.7434 123.392L56.3987 134.097H49.9573L62.884 123.392H66.7434Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9295 119.36C35.1699 119.316 36.3875 119.014 37.5046 118.473C38.6218 117.933 39.6138 117.165 40.4176 116.219C41.2213 115.273 41.819 114.17 42.1725 112.98C42.5261 111.791 42.6277 110.54 42.4709 109.309C42.2484 107.553 41.5136 105.911 40.9945 104.219C40.0136 101.02 39.7002 97.4103 37.4485 94.9328C36.7536 94.1709 35.9074 93.5622 34.964 93.1458C34.0206 92.7294 33.0007 92.5143 31.9694 92.5143C30.9382 92.5143 29.9183 92.7294 28.9749 93.1458C28.0314 93.5622 27.1852 94.1709 26.4903 94.9328C25.0308 96.5339 24.3398 98.6979 24.0398 100.845C23.7398 102.992 23.7803 105.166 23.5949 107.313C23.4264 109.103 23.0859 110.89 23.1601 112.686C23.2342 114.483 23.7735 116.354 25.0915 117.577C25.7643 118.151 26.5158 118.625 27.3229 118.986C28.1 119.419 28.9425 119.722 29.8172 119.883C30.2556 119.961 30.7058 119.939 31.1346 119.819C31.5634 119.7 31.9598 119.485 32.2947 119.192C32.8285 119.327 33.3793 119.384 33.9295 119.36Z",
    fill: "#1A446F"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.9295 119.36C35.1699 119.316 36.3875 119.014 37.5046 118.473C38.6218 117.933 39.6138 117.165 40.4176 116.219C41.2213 115.273 41.819 114.17 42.1725 112.98C42.5261 111.791 42.6277 110.54 42.4709 109.309C42.2484 107.553 41.5136 105.911 40.9945 104.219C40.0136 101.02 39.7002 97.4103 37.4485 94.9328C36.7536 94.1709 35.9074 93.5622 34.964 93.1458C34.0206 92.7294 33.0007 92.5143 31.9694 92.5143C30.9382 92.5143 29.9183 92.7294 28.9749 93.1458C28.0314 93.5622 27.1852 94.1709 26.4903 94.9328C25.0308 96.5339 24.3398 98.6979 24.0398 100.845C23.7398 102.992 23.7803 105.166 23.5949 107.313C23.4264 109.103 23.0859 110.89 23.1601 112.686C23.2342 114.483 23.7735 116.354 25.0915 117.577C25.7643 118.151 26.5158 118.625 27.3229 118.986C28.1 119.419 28.9425 119.722 29.8172 119.883C30.2556 119.961 30.7058 119.939 31.1346 119.819C31.5634 119.7 31.9598 119.485 32.2947 119.192C32.8285 119.327 33.3793 119.384 33.9295 119.36Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8074 125.896V125.448L30.5523 124.818C30.5523 124.818 31.4422 115.717 31.5939 113.081C31.7455 110.445 31.9309 106.292 30.9602 103.279C31.8202 105.334 32.4323 107.483 32.7837 109.683C32.7837 109.683 33.9365 105.537 35.9825 102.898C35.9825 102.898 33.4882 109.268 33.8253 115.194C33.9933 118.562 34.4159 121.912 35.0893 125.215L35.5342 125.512L35.5713 125.886L29.8074 125.896Z",
    fill: "#1A446F"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0825 111.274C32.0825 111.274 31.4353 108.402 29.6926 106.98C29.6926 106.98 31.1521 109.002 31.6308 112.4C32.1094 115.798 32.6184 113.64 32.6184 113.64L32.0825 111.274Z",
    fill: "#1A446F"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3206 119.044C31.1131 118.339 30.6488 117.737 30.0195 117.358C30.0195 117.358 30.6937 118.005 31.0038 120.078C31.3139 122.151 32.0891 121.009 32.0891 121.009L32.1498 119.866L31.3206 119.044Z",
    fill: "#1A446F"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.0104 120.075C30.6734 118.002 30.0262 117.355 30.0262 117.355C30.5056 117.651 30.8931 118.074 31.1453 118.578C31.3475 116.371 31.5363 114.169 31.6003 113.081C31.6003 112.865 31.6239 112.636 31.634 112.407C31.1554 108.995 29.6992 106.986 29.6992 106.986C30.7104 107.812 31.3542 109.13 31.7216 110.088C31.752 107.843 31.6205 105.308 30.9733 103.285C31.8334 105.34 32.4455 107.49 32.7969 109.69C32.7969 109.69 33.9497 105.544 35.9957 102.905C35.9957 102.905 33.5014 109.275 33.8385 115.201C34.0065 118.568 34.4291 121.918 35.1025 125.222L35.5474 125.519L35.5845 125.893H29.8071V125.444L30.552 124.814C30.552 124.814 30.7644 122.62 31.0104 120.075Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M133.217 120.803C131.817 120.753 130.442 120.411 129.181 119.8C127.92 119.19 126.8 118.323 125.893 117.255C124.986 116.187 124.311 114.942 123.911 113.599C123.512 112.256 123.397 110.844 123.574 109.454C123.826 107.472 124.656 105.618 125.242 103.724C126.351 100.11 126.705 96.0351 129.246 93.2407C130.03 92.38 130.985 91.6923 132.05 91.2218C133.115 90.7512 134.266 90.5082 135.43 90.5082C136.594 90.5082 137.745 90.7512 138.81 91.2218C139.875 91.6923 140.83 92.38 141.614 93.2407C143.262 95.0441 144.044 97.4912 144.384 99.9114C144.725 102.332 144.671 104.789 144.897 107.226C145.085 109.248 145.47 111.271 145.389 113.293C145.308 115.316 144.694 117.432 143.208 118.818C142.443 119.467 141.59 120.004 140.673 120.412C139.795 120.901 138.843 121.242 137.855 121.423C137.36 121.511 136.852 121.487 136.367 121.351C135.883 121.216 135.435 120.973 135.058 120.641C134.455 120.785 133.835 120.839 133.217 120.803Z",
    fill: "#1A446F"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M133.217 120.803C131.817 120.753 130.442 120.411 129.181 119.8C127.92 119.19 126.8 118.323 125.893 117.255C124.986 116.187 124.311 114.942 123.911 113.599C123.512 112.256 123.397 110.844 123.574 109.454C123.826 107.472 124.656 105.618 125.242 103.724C126.351 100.11 126.705 96.0351 129.246 93.2407C130.03 92.38 130.985 91.6923 132.05 91.2218C133.115 90.7512 134.266 90.5082 135.43 90.5082C136.594 90.5082 137.745 90.7512 138.81 91.2218C139.875 91.6923 140.83 92.38 141.614 93.2407C143.262 95.0441 144.044 97.4912 144.384 99.9114C144.725 102.332 144.671 104.789 144.897 107.226C145.085 109.248 145.47 111.271 145.389 113.293C145.308 115.316 144.694 117.432 143.208 118.818C142.443 119.467 141.59 120.004 140.673 120.412C139.795 120.901 138.843 121.242 137.855 121.423C137.36 121.511 136.852 121.487 136.367 121.351C135.883 121.216 135.435 120.973 135.058 120.641C134.455 120.785 133.835 120.839 133.217 120.803Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M137.862 128.178V127.676L137.023 126.961C137.023 126.961 136.012 116.677 135.846 113.715C135.681 110.752 135.469 106.05 136.561 102.648C135.591 104.97 134.901 107.4 134.508 109.885C134.508 109.885 133.207 105.207 130.898 102.224C130.898 102.224 133.713 109.417 133.335 116.108C133.143 119.907 132.665 123.686 131.906 127.413L131.404 127.75L131.36 128.168L137.862 128.178Z",
    fill: "#1A446F"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 111.675C135.3 111.675 136.028 108.433 137.997 106.825C137.997 106.825 136.349 109.093 135.809 112.946C135.27 116.799 134.69 114.341 134.69 114.341L135.3 111.675Z",
    fill: "#1A446F"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M136.177 120.446C136.41 119.648 136.935 118.967 137.646 118.538C137.646 118.538 136.895 119.269 136.538 121.609C136.18 123.948 135.307 122.647 135.307 122.647L135.243 121.359L136.177 120.446Z",
    fill: "#1A446F"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.514 121.609C136.871 119.269 137.623 118.538 137.623 118.538C137.079 118.87 136.64 119.349 136.355 119.92C136.13 117.429 135.917 114.941 135.846 113.715C135.846 113.468 135.819 113.209 135.806 112.943C136.345 109.093 137.994 106.825 137.994 106.825C136.848 107.758 136.123 109.245 135.715 110.327C135.681 107.792 135.83 104.934 136.561 102.648C135.591 104.97 134.901 107.4 134.508 109.885C134.508 109.885 133.207 105.207 130.898 102.224C130.898 102.224 133.713 109.417 133.335 116.108C133.143 119.907 132.665 123.686 131.906 127.413L131.404 127.75L131.36 128.168H137.862V127.666L137.023 126.951C137.023 126.951 136.787 124.484 136.514 121.609Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/siteIcon.5bc116b2eb97f4bdcd582be9674e26ba.svg";
export { ForwardRef as ReactComponent };